import React from 'react';
import { Amplify, Auth, I18n } from 'aws-amplify';
import { Authenticator, translations } from '@aws-amplify/ui-react';
import PropTypes from 'prop-types';
import '@aws-amplify/ui-react/dist/styles.css';
import { createUser } from 'wordpress';
import awsExports from 'aws-exports';

I18n.putVocabularies(translations);
I18n.setLanguage('fr');

Amplify.configure(awsExports);

export default function AuthenticatorWithEmail(props) {
  const { children } = props;
  const formFields = {
    signUp: {
      email: {
        order: 1
      },
      username: {
        order: 2,
        isRequired: true,
      },
      middle_name: {
        order: 3,
        placeholder: 'Prénom',
        isRequired: true,
      },
      family_name: {
        order: 4,
        placeholder: 'Nom',
        isRequired: true,
      },
      phone_number: {
        order: 5,
        placeholder: 'Mobile',
        dialCode: '+33',
        isRequired: true,
      },
      profile: {
        order: 6,
        placeholder: 'Entreprise',
        isRequired: true,
      },
      password: {
        order: 7
      },
      confirm_password: {
        order: 8
      },
    },
  };
  const services = {
    async handleSignUp(formData) {
      let { username } = formData;
      const { password, attributes } = formData;
      const {
        // eslint-disable-next-line camelcase
        family_name, middle_name
      } = attributes;
      username = username.toLowerCase();
      attributes.email = attributes.email.toLowerCase();
      createUser(username, attributes.email.toLowerCase(), password, family_name, middle_name);
      return Auth.signUp({
        username,
        password,
        attributes,
      });
    },
  };

  return (
    <Authenticator services={services} formFields={formFields} initialState="signIn">
      {children}
    </Authenticator>
  );
}

AuthenticatorWithEmail.propTypes = {
  children: PropTypes.element
};
